import React from "react";

import { Event } from "lib/build/events";

import { api } from "src/common/utils/api";
import { useCreateGenericError } from "src/features/notifications";
import { useOrgModParams } from "src/features/orgmod";
import {
	PatientConditionReportValue,
	PatientConditionValue
} from "src/modules/basic-health/status-history/types";

interface UsePatientConditionEventsResult {
	isLoading: boolean;
	events: Event<PatientConditionValue | PatientConditionReportValue>[];
}

export function usePatientConditionEvents(
	patientId: string
): UsePatientConditionEventsResult {
	const { org, mod } = useOrgModParams();
	const [{ isLoading, events }, setState] =
		React.useState<UsePatientConditionEventsResult>({
			isLoading: false,
			events: []
		});
	const createGenericError = useCreateGenericError();
	React.useEffect(() => {
		(async () => {
			setState(state => ({ ...state, isLoading: true }));
			try {
				const { data } = await api.get<
					| Event<
							PatientConditionValue | PatientConditionReportValue
					  >[]
					| null
				>(
					`/events/${patientId}?organization=${org}&module=${mod}&i=basic_health|patient_condition&i=basic_health|patient_condition_report`
				);
				setState(state => ({
					...state,
					isLoading: false,
					events: data || []
				}));
			} catch {
				setState(state => ({ ...state, isLoading: false }));
				createGenericError();
			}
		})();
	}, [patientId, org, mod, createGenericError]);
	return { isLoading, events };
}
